<create-or-edit-pendency-body [maintenance]="maintenance" (closeDialogEvent)="closeDialogEvent($event)">
</create-or-edit-pendency-body>
